
import React, { useEffect } from "react";
import "./AllUsers.css";
import FilterAllUsers from "../../Components/FilterAllUsers/FilterAllUsers";
import UsersTable from "../../Components/UsersTable/UsersTable";
import Pagination from "../../Components/Pagination/Pagination";
import { getAllClients } from "../../api";
import DeleteUser from "../../Components/DeleteUser/DeleteUser";
import UserUpdate from "./UserUpdate";
import ErrorUpdate from "./ErrorUpdate"
import { useGlobalContext } from "../../context";
import chunk from "chunk";

function AllUsers() {

    const {
        allUsers, setAllUsers,
        showUsers, setShowUsers,
        chunkData, setChunkData,
        tableData, setTableData
    } = useGlobalContext()

    const getAllClientsData = async () => {
        const data = await getAllClients();
        if (data) {
            setAllUsers(data.data);
        }
    }

    useEffect(() => {
        getAllClientsData();
    },[])

    useEffect(() => {
        const usersData = allUsers.map(item => { return { ...item, active: false } });
        setShowUsers(usersData);
    },[allUsers])

    useEffect(() => {
        setChunkData(chunk(showUsers,100));
    }, [showUsers])

    return(
        <div className = "AllUsersPage">
            <FilterAllUsers/>
            <UsersTable 
                tableData = { tableData }
                getAllClientsData = { getAllClientsData }
            />
            <Pagination 
                chunkData = { chunkData }
                setTableData = { setTableData }
            />
            <DeleteUser 
                getAllClientsData = { getAllClientsData }
            />
            <UserUpdate/>
            <ErrorUpdate/>
        </div>
    )
}

export default AllUsers


